let globalHistory;

export const setHistory = (h) => {
    globalHistory = h;
};

export const getHistory = () => globalHistory;
